import React from "react"
import {graphql, useStaticQuery} from "gatsby"
import {useEffect} from "react"
import {seoState, mouseMovedState} from "../atoms"
import {useSetRecoilState} from "recoil"
import {StoryOverlay, HomepageOverlay} from "."

import {Story} from "../types"

interface Props {
  currentStory?: Story
}

const Overlay = (props: Props): JSX.Element => {
  const setMouseMoved = useSetRecoilState(mouseMovedState)
  const setSeo = useSetRecoilState(seoState)

  let timeout: NodeJS.Timeout
  const onMouseMove = () => {
    setMouseMoved(true)
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      setMouseMoved(false)
    }, 1500)
    return () => clearTimeout(timeout)
  }

  useEffect(() => {
    document.addEventListener("mousemove", onMouseMove)

    return () => {
      document.removeEventListener("mousemove", onMouseMove)
    }
  }, [])

  useEffect(() => {
    if (props.currentStory) {
      setSeo(props.currentStory.seo)
    }
  }, [props.currentStory])

  const data = useStaticQuery(graphql`
    query StoriesQuery {
      allDatoCmsStory {
        edges {
          node {
            title
            slug
            thumbnail {
              url
            }
            video {
              landscape
              portrait
              duration
              subtitles {
                url
              }
              portraitImage {
                url
              }
              landscapeImage {
                url
              }
            }
            subjectPerson
            subjectProject
            indexHighlights {
              from
              to
            }
            playOrder
            seo {
              title
              description
              image {
                url
              }
            }
          }
        }
      }
    }
  `)
  const stories: Story[] = data.allDatoCmsStory.edges
    .map((story: {node: Story}) => story.node)
    .sort((a: Story, b: Story) => a.playOrder - b.playOrder)

  if (props.currentStory) {
    return <StoryOverlay stories={stories} {...props} />
  } else {
    return <HomepageOverlay stories={stories} />
  }
}

export default Overlay
